import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.83798 7.99512H13.4005M7.30673 12.8701L2.71611 8.27949C2.64167 8.20355 2.59998 8.10145 2.59998 7.99512C2.59998 7.88878 2.64167 7.78668 2.71611 7.71074L7.30673 3.12012",
		stroke: "currentColor",
		strokeWidth: 1.5
	})
});
export default SvgArrowLeft;
